// ─── SETTLEMENT HISTORY: paid status that follows the Payouts tab ─────────────────────────────────────────────────
// A History row keeps its own "paid" flag per store, set only by its own Mark Paid button — but payouts are actually made
// (one by one) in the Payouts tab, which stamps `payout_id` on the orders. So History kept showing every settlement as
// Unpaid. The truth is on the orders: a store's part of a settlement is paid when every confirmed order of that store that
// settled on that day carries a payout_id. Display only — nothing is written, nobody is notified.
const dayOf = (iso) => String(iso || "").slice(0, 10);

const cache = new WeakMap();   // orders array → index (rebuilt only when the orders list is replaced)

// Map "storeId|YYYY-MM-DD" → { n: confirmed settled orders, paid: how many of them have a payout_id }
export function paidIndexOf(orders) {
  if (!Array.isArray(orders)) return new Map();
  const hit = cache.get(orders);
  if (hit) return hit;
  const idx = new Map();
  for (const o of orders) {
    if (!o || o.status !== "confirmed" || !o.rzp_settled_at) continue;
    const k = `${o.store_id}|${dayOf(o.rzp_settled_at)}`;
    const e = idx.get(k) || { n: 0, paid: 0 };
    e.n++; if (o.payout_id) e.paid++;
    idx.set(k, e);
  }
  cache.set(orders, idx);
  return idx;
}

// "paid"  → every confirmed order that store settled that day is already paid out
// "due"   → at least one is still unpaid (keep the Mark Paid button)
// "none"  → no confirmed order for that store on that day (e.g. refunded since) — nothing is owed
export function storePayState(index, storeId, settledOn) {
  const e = index.get(`${storeId}|${dayOf(settledOn)}`);
  if (!e || e.n === 0) return "none";
  return e.paid === e.n ? "paid" : "due";
}
